const haiso_c_form = document.querySelector('#cart');
const haiso_c_observer = new MutationObserver(haisocfHandleFormChange);
//日付非表示商品タグ名
const haiso_c_tagName = "mailbox";
//アプリ設定画面上　日付指定属性名　時間帯指定属性名
const haiso_c_attributeKeys = ['haisoShippingdate', 'haisoyamatoshippingtime'];

function haisocfHandleFormChange(mutationsList, observer) {
  for (let mutation of mutationsList) {
    if (mutation.type === 'childList') {

      mutation.addedNodes.forEach(node => {

        if (node.classList && node.classList.length > 0) {

          const className = node.classList[0];
          if (className.includes("cart-items")) {
            haisocfCheckCartItemsForTag(haiso_c_tagName);
          }
        }
      });

      mutation.removedNodes.forEach(node => {

        if (node.classList && node.classList.length > 0) {

          const className = node.classList[0];
          if (className.includes("cart-items")) {
            haisocfCheckCartItemsForTag(haiso_c_tagName);
          }
        }
      });


    }
  }
}
haiso_c_observer.observe(haiso_c_form, { childList: true, subtree: true });


function haisocfCheckCartItemsForTag(tag) {

  var divElements = document.getElementsByClassName("item_tags");

  const haisoDivToHide = document.getElementById('haisosm');
  
     var hide = true;
  
   if(!divElements.length > 0){
         hide = true;
   };
  
    for (var i = 0; i < divElements.length; i++) {
      var divContent = divElements[i].innerHTML;

    if (!divContent || !divContent.includes(tag)) {
            hide = false;
            break;
        }
    }
  
  if (hide) {
    haisoDivToHide.style.display = 'none';
          haisocfRemoveAttributesWithKeys();
  } else {
          haisoDivToHide.style.display = 'block';
  }
}


function haisocfRemoveAttributesWithKeys() {
  // Retrieve the current cart data
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  })
    .then(response => response.json())
    .then(data => {
      const cartAttributes = data.attributes;

      for (const key of haiso_c_attributeKeys) {
        if (cartAttributes[key]) {
          data.attributes[key] = ''
        };
      }


      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(data => {
          haisocfUpdateCurrentAtttibute();
        })
        .catch(error => {
          console.error('Error:', error);
        });
    })
    .catch(error => {
      console.error('Error:', error);
    });
}

function haisocfUpdateCurrentAtttibute() {

  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  })
    .then(response => response.json())
    .then(data => {

      const cartAttributes = data.attributes;
      for (const key of haiso_c_attributeKeys) {
        if (!cartAttributes[key]) {
          const inputElements = document.querySelectorAll(`input[name="attributes[${key}]"]`);
          inputElements.forEach(div => {
            div.value = ''
          });
          const selectElements = document.querySelectorAll(`select[name="attributes[${key}]"]`);
          selectElements.forEach(div => {
            div.value = ''
          });
        };
      }

    })
};

haisocfCheckCartItemsForTag(haiso_c_tagName);